import React from 'react';

import Dropdown from 'components/Dropdown';

const PredesignedDatasetsDropdownComponent = props => (
  <div
    className="main-dropdown mb-20"
    id="predesigned-datasets-dropdown"
  >

    <Dropdown {...props} />
  </div>
);

export default PredesignedDatasetsDropdownComponent;
